import Modal from "@ui-components/Modal";
import { useIntl } from "react-intl";
import Button from "../../../ui-components/Button";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import { useState } from "react";

export const ReactivateModal = (
  {
    closeModal,
    selectedWorksite,
    setSelectedWorksite,
  }: {
    closeModal: () => void;
    selectedWorksite: any;
    setSelectedWorksite: (worksite: any) => void;
  }
) => {
  const countryApiRequest = useCountryAxiosInstance();
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  return (
    <Modal
      onExit={closeModal}
      title={undefined}
      description={undefined}
      onDismiss={undefined}
      onConfirm={undefined}
    >
      <div>
        <div className="mb-4">
          <span>{intl.formatMessage({id:"reactivate_worksite_confirmation_message", defaultMessage:"sei sicuro di voler riattivare il cantiere?"})}</span>
        </div>
        <div className="flex flex-row items-center justify-center gap-2">
          <Button
            onClick={closeModal}
            styleType={"white"}
          >
            {intl.formatMessage({id:"cancel", defaultMessage:"Annulla"})}
          </Button>
          <Button
            loading={loading}
            onClick={async () => {
              const updatedWorksite = await countryApiRequest.post(
                `/worksites/${selectedWorksite.id}/reactivate`
              );
              setSelectedWorksite(updatedWorksite);
              closeModal();
            }}
          >
            {intl.formatMessage({id:"confirm", defaultMessage:"Conferma"})}
          </Button>
        </div>
      </div>
    </Modal>
  )
}